module.exports = __webpack_public_path__ + "img/MirrorCut2.384969ec.png";